import { createApp } from "vue/dist/vue.esm-bundler";
import App from "components/App.vue";

document.addEventListener("DOMContentLoaded", () => {
  const app = createApp(App);
  app.mount("#vueApp");
});
